// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import visitParticipantEntity from './entities/visit-participant.json';
import visitParticipantMenu from '../pages/visit-participant/menu.json';
import visitParticipantFullForm from '../pages/visit-participant/forms/full.json';
import visitParticipantContextForm from '../pages/visit-participant/forms/context.json';
import visitParticipantMiniForm from '../pages/visit-participant/forms/mini.json';
import visitParticipantLookupForm from '../pages/visit-participant/forms/lookup.json';
import visitParticipantTableView from '../pages/visit-participant/views/table.json';
import visitParticipantCardsView from '../pages/visit-participant/views/cards.json';
import visitParticipantCalendarView from '../pages/visit-participant/views/calendar.json';
import visitParticipantDashboardView from '../pages/visit-participant/views/dashboard.json';

/** Тип запису «Учасник візиту» зі сторінками пакета: меню, форми та подання з pages/visit-participant/. */
export const visitParticipantDefinition: IRecordTypeDefinition = {
  ...visitParticipantEntity,
  views: assembleViewSet({
      table: visitParticipantTableView,
      cards: visitParticipantCardsView,
      calendar: visitParticipantCalendarView,
      dashboard: visitParticipantDashboardView,
  }),
  form: visitParticipantFullForm,
  forms: { full: visitParticipantFullForm, context: visitParticipantContextForm, mini: visitParticipantMiniForm, lookup: visitParticipantLookupForm },
  menu: visitParticipantMenu,
} as IRecordTypeDefinition;
